import { mapModes } from 'client/utils/constants/appStates';
const { DEFAULT, AOI } = mapModes;

export const VALID_MODES = [
    [DEFAULT, AOI]
];
